import { useCssHandles } from '../../../../utils/functions';
import { useSearchTitleV2 } from '../hooks/useSearchTitleV2';
const CSS_HANDLES = ['galleryTitle'] as const;
const Content = () => {
	const { mzSearchDummyTitle, componentId } = useSearchTitleV2();
	const { withModifiers }: any = useCssHandles('vtex-search-result-3-x', CSS_HANDLES);
	const classes = withModifiers('galleryTitle', ['layout']);

	return (
		<h1 data-selection={componentId} className={`${classes} t-heading-1`}>
			{mzSearchDummyTitle ?? 'camisa'}
		</h1>
	);
};

export default Content;
